if (!customElements.get('show-more-button')) {
  customElements.define(
    'show-more-button',
    class ShowMoreButton extends HTMLElement {
      constructor() {
        super();
        /** @type {HTMLButtonElement | null} */
        const button = this.querySelector('button');
        if (button) {
          button.addEventListener('click', (event) => {
            this.expandShowMore(event);
            /** @type {HTMLElement | null} */
            const target = /** @type {HTMLElement} */ (event.target);
            /** @type {HTMLElement | null} */
            const parentDisplay = target.closest('.parent-display');
            /** @type {HTMLElement | null} */
            const nextElementToFocus = parentDisplay ? parentDisplay.querySelector('.show-more-item') : null;
            if (nextElementToFocus && !nextElementToFocus.classList.contains('hidden')) {
              /** @type {HTMLInputElement | null} */
              const inputElement = nextElementToFocus.querySelector('input');
              if (inputElement) {
                inputElement.focus();
              }
            }
          });
        }
      }
      /**
       * @param {MouseEvent} event
       * @returns {void}
       */
      expandShowMore(event) {
        /** @type {HTMLElement | null} */
        const target = /** @type {HTMLElement} */ (event.target);
        /** @type {HTMLElement | null} */
        const showMoreElement = target.closest('[id^="Show-More-"]');
        /** @type {HTMLElement | null} */
        const parentDisplay = showMoreElement ? showMoreElement.closest('.parent-display') : null;
        if (!parentDisplay) {return;}
        this.querySelectorAll('.label-text').forEach((/** @type {Element} */ element) => element.classList.toggle('hidden'));
        parentDisplay.querySelectorAll('.show-more-item').forEach((/** @type {Element} */ item) => item.classList.toggle('hidden'));
        if (!this.querySelector('.label-show-less')) {
          this.classList.add('hidden');
        }
      }
    }
  );
}
